import { FaqData } from '../types'
import {
  amazonRelationshipSection,
  customerOrdersSection,
  doingBusinessSection,
  launchingDealSection,
  returnsCustomerServiceSection,
  vendorOnboardingSection,
  vendorPaymentSection,
} from './faq-sections'

/**
 * FAQ data
 * Contains all FAQ categories and items
 */
export const faqData: FaqData = {
  categories: [
    doingBusinessSection,
    vendorOnboardingSection,
    launchingDealSection,
    customerOrdersSection,
    vendorPaymentSection,
    returnsCustomerServiceSection,
    amazonRelationshipSection,
  ],
}
